import React, { useState, useEffect } from "react";
import { I2cButton } from "@webcomponents/i2cwebcomponents/dist/react";
import Banner from "../../Components/Banner/Banner";
import ConcurrentTable from "../../Components/ConcurrentTable/ConcurrentTable";
import illustration from "../../assets/images/concurrent-session-banner.svg";
import illustrationDark from "../../assets/images/concurrent-session-banner-dmode.svg";
import ConcurrentSessionService from "../../Services/ConcurrentSession";
import { useNavigate } from "react-router-dom";
import { UserStateContext } from "../../Context/AuthContext";
import "./ConcurrentSession.scss";
import SecureFooter from "../../Components/SecureFooter/SecureFooter";
import { useQueryClient } from "react-query";

/**
 * Component for managing concurrent sessions.
 * Displays concurrent sessions information and provides options to keep sessions alive or kill all sessions.
 * @returns JSX.Element
 */
const ConcurrentSession = () => {
  // State to manage loading state
  const [killAllloading, setKillAllLoading] = useState(false);
  const [keepAliveloading, setKeepAliveloading] = useState(false);
  // Context for user state
  const appContext = UserStateContext();

  // Navigation hook
  const navigate = useNavigate();

  // Function to handle killing all sessions
  const handleAllSessionsKill = async () => {
    // Set loading state
    setKillAllLoading(true);
    // Call API to kill all sessions
    const response = await ConcurrentSessionService.killAllSessions();
    // Reset loading state
    setKillAllLoading(false);
    // If successful response, update session count and navigate to dashboard
    if (response.data.status) {
      appContext.setSessionCount(0);
      navigate("/sales");
    }
  };

  // Function to handle keeping sessions alive
  const handleKeepSessionsAlive = async () => {
    // Set loading state
    setKeepAliveloading(true);
    // Call API to keep sessions alive
    const response = await ConcurrentSessionService.keepSessionsAlive();
    // Reset loading state
    setKeepAliveloading(false);
    // If successful response, update session count and navigate to dashboard
    if (response.data.status) {
      appContext.setSessionCount(0);

      const userRole = appContext.userRole;
      if (userRole === 5) {
        navigate("/impl");
      } else {
        navigate("/sales");
      }
    }
  };

  return (
    <>
      <div className="concurrent-session-container">
        {/* Banner component */}
        <Banner
          bannerImage={appContext.darkMode ? illustrationDark : illustration}
          bannerTitle="Concurrent Session"
          bannerDescription="You've already signed in using the same credentials. Please see the information below. Kindly kill or stay alive to proceed."
        />
        {/* Concurrent table component */}
        <div className="concurrentTable__wrap">
          <ConcurrentTable />
        </div>
        {/* Button container */}
        <div
          className="btn-container-concurrent-session"
          i2c-container="container xl"
        >
          <div className="concurrent__btns">
            {/* Keep Alive button */}
            <I2cButton
              size="medium"
              variant="secondary gray"
              disabled={keepAliveloading}
              loading={keepAliveloading}
              onClick={handleKeepSessionsAlive}
            >
              Keep Alive
            </I2cButton>
            {/* Kill All button */}
            <I2cButton
              size="medium"
              disabled={killAllloading}
              variant="primary"
              loading={killAllloading}
              onClick={handleAllSessionsKill}
            >
              Kill All
            </I2cButton>
          </div>
        </div>
      </div>
      <SecureFooter containerClass="fixed-footer" />
    </>
  );
};

export default ConcurrentSession;
